import { IGachaAccountState, IGachaBanner, IGachaBannerInvoiceItem, IGachaBannerReward, IGachaBannerRewardsGroup } from '~/types/gacha';
import { MercatorMysteryContentState } from '~/types/mercator';
import { arrayToObjectByKey, isEmptyObject } from '~/utils/utils';

export function getRecivedRewardsByNames(names: string[], banner: IGachaBanner): IGachaBannerReward[] {
    const rewards: IGachaBannerReward[] = [];

    names.forEach((name) => {
        const paidReward = getRewardByName(banner.rewardsGroups, name);
        const freeReward = getRewardByName([banner.freeRewards], name);
        paidReward && rewards.push(paidReward);
        freeReward && rewards.push(freeReward);
    });

    return rewards;
}

export function getRewardByName(groups: IGachaBannerRewardsGroup[], name: string): Nullable<IGachaBannerReward> {
    for (let i = 0; i < groups.length; i++) {
        for (let j = 0; j < groups[i].subgroups.length; j++) {
            const rewardsMap = arrayToObjectByKey(groups[i].subgroups[j].rewardBundles, 'name');
            if (rewardsMap[name]) {
                return rewardsMap[name];
            }
        }
    }

    return null;
}

export function isRecivedAllPaidRewards(banner: IGachaBanner, accountState: IGachaAccountState) {
    if (!accountState || isEmptyObject(accountState)) {
        return false;
    }
    return banner.rewardsGroups.every((group) => {
        return group.subgroups.every((subgroup) => {
            return subgroup.rewardBundles.every((bundle) => {
                return accountState.receivedRewards.includes(bundle.name);
            });
        });
    });
}

export function prepareMysteryBundlesForState(banners: MercatorMysteryContentState) {
    Object.values(banners).forEach((banner: IGachaBanner) => {
        banner.freeRewards.subgroups.forEach((group) => {
            group.rewardBundles.forEach((bundle) => {
                bundle.isExtraReward = true;
            });
        });
    });
    return banners;
}

export function getPrimaryReward(items: IGachaBannerInvoiceItem[]) {
    return items.find((item) => item.isPrimary);
}
